export default ['JsonRPCService', 'JobService', (JsonRPCService, JobService) => {
    return {
        createSubmission: (newSubmission) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'createNewSubmission', [newSubmission]);
        },
        findJobByJobNumber: (submissionNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'findJobByJobNumber', [submissionNumber]);
        },
        getSubmissionSummary: (submissionNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'getSubmissionSummary', [submissionNumber]);
        },
        getNotesForSubmission: (submissionNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'getNotesForSubmission', [submissionNumber]);
        },
        createNoteForSubmission: (submissionNumber, noteDTO) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'createNoteForSubmission', [submissionNumber, noteDTO]);
        },
        getDocumentsForSubmission: (submissionNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'getDocumentsForSubmission', [submissionNumber]);
        },
        getUWIssuesForSubmission: (submissionNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'getUWIssuesForSubmission', [submissionNumber]);
        },
        referToUnderwriter: (submissionNumber, noteBody) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'referToUnderwriter', [submissionNumber, noteBody]);
        },
        approveUnderwritingIssue: (submissionNumber, uwIssue) => {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'approveUnderwritingIssue', [submissionNumber, uwIssue]);
        },
        withdrawSubmissionBySubmissionNumber: (submissionNumber) => {
            return JobService.withdrawJobByJobNumber(submissionNumber);
        }

    };
}];